import { render, staticRenderFns } from "./chronic.vue?vue&type=template&id=dd776548&scoped=true"
import script from "./chronic.vue?vue&type=script&lang=js"
export * from "./chronic.vue?vue&type=script&lang=js"
import style0 from "./chronic.vue?vue&type=style&index=0&id=dd776548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd776548",
  null
  
)

export default component.exports